import { Footer } from 'components/Footer/Footer';
import { Header } from 'components/Header/Header';
import { Heading } from 'components/Heading/Heading';
import { ReactComponent as RemoveCircle } from 'icons/remove-circle.svg';
import { useTranslations } from 'utils/translations/useTranslations';

function OrderNotFound() {
  const i18n = useTranslations();

  return (
    <div className="Site">
      <Header />
      <main id="content" tabIndex={-1} className="ErrorPage">
        <RemoveCircle aria-hidden="true" focusable="false" />
        <Heading as="h1" size="huge" className="ErrorPage-title">
          {i18n.t('prefillOrderAndPay.errorTitle')}
        </Heading>
        <p className="fontSize-lg marginBottom-sm">
          {i18n.t('prefillOrderAndPay.notFound')}
        </p>
      </main>
      <Footer />
    </div>
  );
}

export { OrderNotFound };
